/* Mavras: logoya fare gelince veya tıklanınca mavi kavis üzerinde zeytin dalı oluşur, zeytinler düşüp dala tutunur. */
(function () {
  if (window.MavrasLogoOlives) return;
  window.MavrasLogoOlives = true;

  var cfg = window.MavrasLogoOlivesConfig || {};
  var PER_DROP = cfg.perClick || 8;
  var TRIGGER = cfg.trigger || 'both';
  var IS_HOME = !!cfg.isHome;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var SVGNS = 'http://www.w3.org/2000/svg';

  // Logodaki mavi kavisin üst kenarı (görselin genişliğine ve yüksekliğine oranla)
  var CURVE = [
    [0.00, 0.98], [0.08, 0.81], [0.17, 0.77], [0.25, 0.74], [0.33, 0.72], [0.42, 0.71],
    [0.50, 0.71], [0.58, 0.71], [0.66, 0.72], [0.75, 0.75], [0.83, 0.80], [0.91, 0.87], [1.00, 0.97]
  ];
  function curveY(t) {
    for (var i = 1; i < CURVE.length; i++) {
      if (t <= CURVE[i][0]) {
        var a = CURVE[i - 1], b = CURVE[i];
        return a[1] + (b[1] - a[1]) * ((t - a[0]) / (b[0] - a[0]));
      }
    }
    return CURVE[CURVE.length - 1][1];
  }

  var T_START = 0.07, T_END = 0.93;
  var NODES = 11; // zeytinlerin tutunacağı noktalar
  var COLORS = [['#8a9a3a', '#55621f'], ['#6f7d2a', '#3f4a16'], ['#4a3b33', '#1e1714'], ['#6b4148', '#3a2226']];
  var uid = 0;

  function el(name, attrs) {
    var n = document.createElementNS(SVGNS, name);
    for (var k in attrs) n.setAttribute(k, attrs[k]);
    return n;
  }

  function oliveSvg(size) {
    var c = COLORS[Math.floor(Math.random() * COLORS.length)];
    var id = 'mo-olive-g' + (uid++);
    return '<svg width="' + size + '" height="' + Math.round(size * 1.25) + '" viewBox="0 0 24 30" aria-hidden="true">' +
      '<defs><radialGradient id="' + id + '" cx="35%" cy="30%" r="75%"><stop offset="0" stop-color="' + c[0] + '"/><stop offset="1" stop-color="' + c[1] + '"/></radialGradient></defs>' +
      '<path d="M12 6 C 12 3, 13 1, 14 0" stroke="#6b5a3a" stroke-width="1.6" fill="none"/>' +
      '<ellipse cx="12" cy="18" rx="9" ry="11.5" fill="url(#' + id + ')"/>' +
      '<ellipse cx="8.5" cy="13" rx="2.4" ry="3.4" fill="#fff" opacity=".35"/>' +
      '</svg>';
  }

  function findLogos() {
    var imgs = document.querySelectorAll('.site-header__logo img, .mobile-nav-bar-wrapper .site-header__logo img');
    return Array.prototype.filter.call(imgs, function (img) { return img.closest('a'); });
  }

  function layerFor(img) {
    var host = img.closest('a').parentElement;
    var layer = host.querySelector(':scope > .mo-olive-layer');
    if (!layer) {
      if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
      layer = document.createElement('div');
      layer.className = 'mo-olive-layer';
      layer.setAttribute('aria-hidden', 'true');
      layer.style.cssText = 'position:absolute;inset:0;pointer-events:none;overflow:visible;z-index:5;';
      host.appendChild(layer);
      layer._nodes = [];
    }
    return layer;
  }

  // Mavi kavis boyunca dal ve yapraklar
  function growBranch(layer, img) {
    if (layer._branch) return;
    var hostRect = layer.getBoundingClientRect();
    var r = img.getBoundingClientRect();
    var W = r.width, H = r.height;
    var lift = Math.max(1, H * 0.02);
    var svg = el('svg', { width: W, height: H, viewBox: '0 0 ' + W + ' ' + H, style: 'position:absolute;left:' + (r.left - hostRect.left) + 'px;top:' + (r.top - hostRect.top) + 'px;overflow:visible;' });

    var pts = [];
    for (var i = 0; i <= 24; i++) {
      var t = T_START + (T_END - T_START) * (i / 24);
      pts.push([t * W, curveY(t) * H - lift]);
    }
    var d = 'M' + pts[0][0].toFixed(1) + ' ' + pts[0][1].toFixed(1);
    for (var j = 1; j < pts.length; j++) d += ' L' + pts[j][0].toFixed(1) + ' ' + pts[j][1].toFixed(1);
    var stemW = Math.max(1.2, W * 0.012);
    var stem = el('path', { d: d, fill: 'none', stroke: '#6b5a3a', 'stroke-width': stemW, 'stroke-linecap': 'round' });
    svg.appendChild(stem);

    var leafLen = Math.max(7, W * 0.075);
    var leaves = [];
    var count = 9;
    for (var k = 0; k < count; k++) {
      var t2 = T_START + 0.04 + (T_END - T_START - 0.08) * (k / (count - 1));
      var x = t2 * W, y = curveY(t2) * H - lift;
      var x2 = (t2 + 0.01) * W, y2 = curveY(t2 + 0.01) * H - lift;
      var ang = Math.atan2(y2 - y, x2 - x) * 180 / Math.PI;
      var side = k % 2 === 0 ? -1 : 1;
      var rot = ang + side * 35 + (Math.random() * 10 - 5);
      var g = el('g', { transform: 'translate(' + x.toFixed(1) + ' ' + y.toFixed(1) + ') rotate(' + rot.toFixed(1) + ')' });
      var leaf = el('path', {
        d: 'M0 0 C ' + (leafLen * 0.3) + ' ' + (-leafLen * 0.22) + ', ' + (leafLen * 0.75) + ' ' + (-leafLen * 0.2) + ', ' + leafLen + ' 0 C ' + (leafLen * 0.75) + ' ' + (leafLen * 0.2) + ', ' + (leafLen * 0.3) + ' ' + (leafLen * 0.22) + ', 0 0 Z',
        fill: k % 3 === 0 ? '#5f7a35' : '#7f9a4a'
      });
      g.appendChild(leaf);
      svg.appendChild(g);
      leaves.push(leaf);
    }
    layer.insertBefore(svg, layer.firstChild);
    layer._branch = svg;

    if (reduce || !stem.animate) return;
    var len = stem.getTotalLength ? stem.getTotalLength() : W;
    stem.style.strokeDasharray = len;
    stem.animate([{ strokeDashoffset: len }, { strokeDashoffset: 0 }], { duration: 700, easing: 'ease-out', fill: 'both' });
    leaves.forEach(function (lf, i) {
      lf.style.transformBox = 'fill-box';
      lf.style.transformOrigin = '0% 50%';
      lf.animate([{ transform: 'scale(0)', opacity: 0 }, { transform: 'scale(1)', opacity: 1 }],
        { duration: 450, delay: 250 + i * 60, easing: 'cubic-bezier(.3,1.4,.6,1)', fill: 'both' });
    });
  }

  function drop(img) {
    var layer = layerFor(img);
    var r = img.getBoundingClientRect();
    if (!r.width) return;
    growBranch(layer, img);

    var hostRect = layer.getBoundingClientRect();
    var size = Math.max(9, Math.round(r.width * 0.085));
    var h = Math.round(size * 1.25);
    var offX = r.left - hostRect.left;
    var offY = r.top - hostRect.top;
    var nodes = layer._nodes;

    for (var i = 0; i < PER_DROP; i++) {
      (function (i) {
        var free = [];
        for (var n = 0; n < NODES; n++) if (!nodes[n]) free.push(n);
        var node;
        if (free.length) {
          node = free[Math.floor(Math.random() * free.length)];
        } else {
          // dal doluysa en eski zeytini kaldırıp yerine yenisini koy
          var oldest = layer.querySelector('.mo-olive');
          if (!oldest) return;
          node = oldest._node;
          oldest.remove();
        }
        var t = T_START + 0.03 + (T_END - T_START - 0.06) * (node / (NODES - 1));
        var x = offX + t * r.width - size / 2;
        var yLand = offY + curveY(t) * r.height - h * 0.92;
        var yStart = -r.top - 40 - Math.random() * 120 + offY;
        var rot = Math.round(Math.random() * 30 - 15);

        var o = document.createElement('span');
        o.className = 'mo-olive';
        o.style.cssText = 'position:absolute;left:' + x + 'px;top:0;width:' + size + 'px;height:' + h + 'px;will-change:transform;';
        o.innerHTML = oliveSvg(size);
        o._node = node;
        nodes[node] = o;
        layer.appendChild(o);
        var origRemove = o.remove.bind(o);
        o.remove = function () { if (nodes[node] === o) nodes[node] = null; origRemove(); };

        if (reduce || !o.animate) {
          o.style.transform = 'translateY(' + yLand + 'px) rotate(' + rot + 'deg)';
          return;
        }
        var dur = 900 + Math.random() * 500;
        o.animate([
          { transform: 'translateY(' + yStart + 'px) rotate(' + (rot - 140) + 'deg)', easing: 'cubic-bezier(.45,0,.9,.6)' },
          { transform: 'translateY(' + yLand + 'px) rotate(' + rot + 'deg)', offset: 0.8, easing: 'ease-out' },
          { transform: 'translateY(' + (yLand - h * 0.35) + 'px) rotate(' + (rot + 8) + 'deg)', offset: 0.9, easing: 'ease-in' },
          { transform: 'translateY(' + yLand + 'px) rotate(' + rot + 'deg)' }
        ], { duration: dur, delay: 350 + i * 110 + Math.random() * 120, fill: 'both' });
      })(i);
    }
  }

  function onClick(e) {
    // Ana sayfada tıklama animasyonu oynatır; diğer sayfalarda logo ana sayfaya götürmeye devam eder.
    if (!IS_HOME) return;
    var img = e.currentTarget.querySelector('img');
    if (!img) return;
    e.preventDefault();
    drop(img);
  }

  function onHover(e) {
    var a = e.currentTarget;
    var now = Date.now();
    if (a._moLast && now - a._moLast < 1200) return;
    a._moLast = now;
    var img = a.querySelector('img');
    if (img) drop(img);
  }

  function init() {
    findLogos().forEach(function (img) {
      var a = img.closest('a');
      if (a.dataset.moOlives) return;
      a.dataset.moOlives = '1';
      if (TRIGGER === 'click' || TRIGGER === 'both') a.addEventListener('click', onClick);
      if (TRIGGER === 'hover' || TRIGGER === 'both') a.addEventListener('mouseenter', onHover);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
